// src/config.js
const config = {
    REACT_APP_API_URL: "https://waterviewai.onrender.com",
    // REACT_APP_API_URL: "http://localhost:8000",

    APP_NAME: "Waterviewai",
    VERSION: "1.0.0",
  };
  
  export default config;
  
